import Styled, { css } from 'styled-components';

import {
  cssDeclaration,
  VALID_DIMENSION_DATA,
  VALID_EDGE_STYLE_DATA,
  VALID_MEDIA_STYLES,
  VALID_SHADOW_DATA,
} from '../Utils';

import { IBoxCommonProps, PositionType } from './common';

export interface IStyledBoxProps extends IBoxCommonProps {
  directionProp?: VALID_MEDIA_STYLES;
  displayProp?: VALID_MEDIA_STYLES;

  /** @deprecated Use boxShadow */
  elevationProp?: VALID_SHADOW_DATA;

  heightProp?: VALID_DIMENSION_DATA;
  marginProp?: string | VALID_EDGE_STYLE_DATA;
  orderProp?: string;
  overflowProp?: string;
  pad?: string | VALID_EDGE_STYLE_DATA;
  positionProp?: PositionType;
  transformProp?: string;
  widthProp?: VALID_DIMENSION_DATA;
}

export const StyledBox = Styled.div<IStyledBoxProps>`
  display: flex;

  ${props => {
    // tslint:disable-next-line: cyclomatic-complexity
    const {
      alignContent,
      alignItems,
      alignSelf,
      backgroundColor,
      border,
      childrenStyles,
      columnGap,
      cursor,
      directionProp,
      displayProp,
      /* tslint:disable-next-line deprecation */
      elevationProp,
      boxShadow,
      flexBasis,
      flexGrow,
      flexShrink,
      flexWrap,
      heightProp,
      justifyContent,
      orderProp,
      overflowProp,
      marginProp,
      pad,
      positionProp,
      /* tslint:disable-next-line deprecation */
      round,
      borderRadius,
      rowGap,
      transformProp,
      theme: { themeTwo },
      widthProp,
      zIndex,
    } = props;

    const shadow = elevationProp || boxShadow;
    const boxShadowProp = shadow && themeTwo.global.elevation[shadow as string] || shadow;
    const radiusBorder = borderRadius || round;
    let positionStyles;
    if (typeof positionProp === 'object') {
      const { type, top, bottom, left, right } = positionProp;

      positionStyles = css`
        /* position */ ${cssDeclaration(themeTwo, 'position', type)};
        /* top */ ${top && cssDeclaration(themeTwo, 'top', top)};
        /* bottom */ ${bottom && cssDeclaration(themeTwo, 'bottom', bottom)};
        /* left */ ${left && cssDeclaration(themeTwo, 'left', left)};
        /* right */ ${right && cssDeclaration(themeTwo, 'right', right)};
      `;
    } else {
      positionStyles = css`
        /* position */ ${positionProp && cssDeclaration(themeTwo, 'position', positionProp)};
      `;
    }

    return css`
      z-index: ${zIndex && themeTwo.global.zIndex[zIndex]};

      /* background-color */ ${backgroundColor && cssDeclaration(themeTwo, 'background-color', backgroundColor)};
      /* position */${positionProp && positionStyles}
      /* align-self */ ${alignSelf && cssDeclaration(themeTwo, 'align-self', alignSelf)};
      /* align-content */ ${alignContent && cssDeclaration(themeTwo, 'align-content', alignContent)};
      /* align-items */ ${alignItems && cssDeclaration(themeTwo, 'align-items', alignItems)};
      /* border */ ${border && cssDeclaration(themeTwo, 'border', border)};
      /* border-radius */ ${radiusBorder && cssDeclaration(themeTwo, 'border-radius', radiusBorder)};
      // tslint:disable:next-line
      /* box-shadow */ ${boxShadowProp && cssDeclaration(themeTwo, 'box-shadow', boxShadowProp)};
      /* column-gap */ ${columnGap && cssDeclaration(themeTwo, 'column-gap', columnGap)};
      /* cursor */ ${cursor && cssDeclaration(themeTwo, 'cursor', cursor)};
      /* display */ ${displayProp && cssDeclaration(themeTwo, 'display', displayProp)};
      /* flex-direction */ ${directionProp && cssDeclaration(themeTwo, 'flex-direction', directionProp)};
      /* flex-basis */ ${flexBasis && cssDeclaration(themeTwo, 'flex-basis', flexBasis)};
      /* flex-grow */ ${flexGrow && cssDeclaration(themeTwo, 'flex-grow', flexGrow)};
      /* flex-shrink */ ${flexShrink && cssDeclaration(themeTwo, 'flex-shrink', flexShrink)};
      /* flex-wrap */ ${flexWrap && cssDeclaration(themeTwo, 'flex-wrap', flexWrap)};
      /* height */ ${heightProp && cssDeclaration(themeTwo, 'height', heightProp)};
      /* justify-content */ ${justifyContent && cssDeclaration(themeTwo, 'justify-content', justifyContent)};
      /* margin */ ${marginProp && cssDeclaration(themeTwo, 'margin', marginProp)};
      /* order */ ${orderProp && cssDeclaration(themeTwo, 'order', orderProp)};
      /* overflow */ ${overflowProp && cssDeclaration(themeTwo, 'overflow', overflowProp)};
      /* padding */ ${pad && cssDeclaration(themeTwo, 'padding', pad)};
      /* row-gap */ ${rowGap && cssDeclaration(themeTwo, 'row-gap', rowGap)};
      /* transform */ ${transformProp && cssDeclaration(themeTwo, 'transform', transformProp)};
      /* width */ ${widthProp && cssDeclaration(themeTwo, 'width', widthProp)};

      // these styles are used to target children of the box component
      ${childrenStyles && childrenStyles};
    `;
  }}
`;

export default StyledBox;
